export const recoCarouselTagName: "reco-carousel" = "reco-carousel" as const;
